<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Measurement Details</h2>
            <div v-if="markdetails.markstatus == 0"class="Row">
             <span  @click="Markstatus(1)" class = "text-danger  mt-2">Processing</span>
             <span  @click="Markstatus(2)" class = "text-success ml-2">Marked</span>
             </div>
            <div class="Row">
             <span  v-if="markdetails.markstatus ==2" @click="Markstatus(1)" class = "text-danger  mt-2">Processing</span>
             <span  v-if="markdetails.markstatus ==1" @click="Markstatus(2)" class = "text-success ml-2">Marked</span>
             </div>
         
        </div>
        
        <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class="dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            
            <div class="tablejs sr-only size-0"></div>
         <!-- ------------------------------------------------------------------------------------------------------ -->



           <div class="col-span-full">
              <div class="card p-4 bg-gray-50 dark:bg-gray-900 rounded-2xl shadow-lg overflow-hidden">
           <div class="space-y-6">
              <div class="grid grid-cols-2 gap-4 sm:grid-cols-2 md:grid-cols-3">
             <div v-for="(item, index) in measurementdetails" :key="item.id"class="bg-white dark:bg-gray-800 shadow-md rounded-xl p-4 hover:shadow-xl transition-shadow duration-300">
              <div class="text-base font-semibold text-black dark:text-white">
                {{ index + 1 }}. {{ item.lable }}:
              </div>
              <div class="mt-1 text-gray-700 dark:text-gray-300 text-sm font-semibold">
                {{ item.lablevalue }}
              </div>
                 <div class="mt-3 flex justify-end">
        </div>
      </div>   
    </div>
  </div>
</div>

            </div>


    <div v-if="markdetails.markstatus == 0"class="Row ml-3 mb-4">
             <span  @click="Markstatus(1)" class = "text-danger  mt-2">Processing</span>
             <span  @click="Markstatus(2)" class = "text-success ml-2">Marked</span>
             </div>

            <div class="Row ml-3 mb-4">
             <span  v-if="markdetails.markstatus ==2" @click="Markstatus(1)" class = "text-danger  mt-2">Processing</span>
             <span  v-if="markdetails.markstatus ==1" @click="Markstatus(2)" class = "text-success ml-2">Marked</span>
             </div>


         


            <!-- ------------------------------------------------------------------------------------------------------ -->
        </div>
    </div>
    <!-- End Main Content -->
    
    <!-- Start Delete Modal -->
    <!-- End Delete Modal -->
</template>
<script>
import axios from 'axios';
export default {
  data() {
    return {
      currentDate: new Date().toLocaleDateString(),
      receiptNumber: '',
      customer:[],   
      measurementdetails:[],
      markid:'',
      markdetails:[],
       
    };
  },
  computed: {
    totalAmount() {
      return this.items.reduce((total, item) => total + item.quantity * item.unitPrice, 0);
    },
  },
  mounted() { 
      if(this.$route.query.q)
            this.getBasics(this.$route.query.q); 
  },
  methods: {
     async getBasics(invoiceid) {
           var self=this;
              self.id = invoiceid
             axios.post('getallmeasurement',{invoiceid:invoiceid}).then(function (response) {
        
                        self.measurementdetails=response.data.measurementdetails;
                        self.markdetails=response.data.markdetails;
                        try {
                            document.getElementById("loader").remove();  
                            sel.printReceipt();
                        } catch (e) {}
                    }).then(()=>{ 
                        
                        
                        
                    //     self.printReceipt();
                  
                        });;
      },
    formatCurrency(value) {
      return value;//`$${value.toFixed(2)}`;
    },
    printReceipt() {
      window.print();
    },


  print_measurement(id)
        {

            alert(id);
             
               // window.open('/print?q='+id, '_blank');
              //  window.open('/MeasurementDetails?q='+id, '_blank'); 
             this.$router.push({ path: '/allmeasurement', query: { q: id } });

        },

     Markstatus(markid) {
          var self=this;

             self.markid = markid;
                        
             axios.post('updatemarkstatus',{
                  id: self.id,
                  markid: self.markid
              }).then(function (response) {
        
                        self.measurementdetails=response.data.measurementdetails;
                        self.markdetails=response.data.markdetails;
                        self.reply=response.data.reply;
                        self.$swal(self.reply);
                   

                    }).then(()=>{ 
                        
                        
                        
                    //     self.printReceipt();
                  
                        });;
      },











  },
};
</script>


